import numeral from "numeral";
import React from "react";
import PropTypes from "prop-types";
import { Icon, ProgressBar } from "@evertrue/et-components";
import { ACTIVITY_TYPES } from "../utils/constants";

const ActivityBreakdown = ({ interactionStatsByType = {}, interactionTotalByPool, showBar = false, ...rest }) => {
  return (
    <>
      <div className="pool-report--label">Activity Type</div>
      {ACTIVITY_TYPES.map(type => {
        const number = interactionStatsByType[type.value] || 0;
        const percentageOfTotal = (number / interactionTotalByPool) * 100 || undefined;
        return (
          <div key={type.value} className="pool-activity-report--type">
            <Icon icon={type.icon} style={{ color: type.iconColor }} size={1} className="pool-activity-report--icon" />
            <span className="pool-activity-report--label">{type.label}</span>
            {showBar && (
              <ProgressBar className="pool-report--progress-bar" backgroundColor={"#fff"} percent={percentageOfTotal} />
            )}
            <span className="pool-activity-report--number">
              {numeral(number / interactionTotalByPool).format("%0.[00]")}
            </span>
          </div>
        );
      })}
    </>
  );
};

ActivityBreakdown.propTypes = {
  interactionStatsByType: PropTypes.object,
  interactionTotalByPool: PropTypes.any,
  showBar: PropTypes.bool,
};

export default ActivityBreakdown;
